import { Note } from '../_types';

const EMERGENCY_CATEGORIES = new Set(['Emergency', 'Urgence']);

export const isEmergencyNote = (note: Note): boolean =>
  note.entity_extractions.some(
    (entity) =>
      entity.extraction_class_key === 'Urgency' &&
      (entity.attributes?.categories ?? []).some((category) =>
        EMERGENCY_CATEGORIES.has(category)
      )
  );

export default isEmergencyNote;
